import { Button, Modal, Text } from '@belong/ui';
import classNames from 'classnames/bind';
import { AppDownPhone } from 'lease-signing-flow-v2/components/app-down-phone/app-down-phone';
import { AppQR } from 'lease-signing-flow-v2/components/app-qr/app-qr';
import { AppStoreBadges } from 'lease-signing-flow-v2/components/app-store-badges/app-store-badges';
import { STRINGS } from './SplashScreen.strings';
import styles from './SplashScreenModal.module.css';

const cx = classNames.bind(styles);

type SplashScreenModalProps = {
  isOpen: boolean;
  onDismiss: () => void;
};

export function SplashScreenModal({
  isOpen,
  onDismiss,
}: SplashScreenModalProps): JSX.Element {
  return (
    <Modal
      contentClassName="flex"
      isOpen={isOpen}
      name="SPLASH_SCREEN_MODAL"
      onDismiss={onDismiss}
      overlayClassName="z-[99999]"
      size="fullScreen"
    >
      <div className="flex w-full flex-col items-center px-xs pt-2xl md:px-0">
        <Text
          variant="h3"
          className={cx('text-center mb-xs', styles.textWidth)}
          fontWeight="semibold"
        >
          {STRINGS.title}
        </Text>
        <Text className={cx('text-center mb-xl md:mb-2xl', styles.textWidth)}>
          {STRINGS.subtitle}
        </Text>
        <div className="flex w-full flex-col md:w-auto md:flex-row md:pl-4xl">
          <div className="md:mr-2xl">
            <AppDownPhone />
          </div>
          <div className="relative md:pt-2xl">
            <div className="hidden md:block">
              <AppQR />
            </div>
            <div
              className="z-10 -mx-xs flex
                flex-col items-center justify-items-start border-0 border-t border-solid
                border-gray bg-white pt-xl md:z-auto md:mx-0 md:mt-xl md:items-start md:border-0 md:pt-0"
            >
              <div className="mb-lg">
                <AppStoreBadges />
              </div>
              <Button buttonType="primary" onClick={onDismiss} variant="text">
                {STRINGS.cta}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
